import { Controller } from "@hotwired/stimulus"

// Live preview under the header search box: fetches /search/suggest as an
// HTML fragment while typing. Enter still submits the form to /search.
export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  suggest() {
    clearTimeout(this.timer)
    const query = this.inputTarget.value.trim()
    if (query.length < 2) return this.close()

    this.timer = setTimeout(() => this.load(query), 150)
  }

  async load(query) {
    this.abort?.abort()
    this.abort = new AbortController()
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
        signal: this.abort.signal,
        headers: { Accept: "text/html" }
      })
      if (!response.ok) return

      const html = await response.text()
      if (query !== this.inputTarget.value.trim()) return

      this.resultsTarget.innerHTML = html
      this.resultsTarget.hidden = html.trim() === ""
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }

  close() {
    this.resultsTarget.hidden = true
  }

  // Keep the preview open while focus moves into it (clicking a result).
  blur(event) {
    if (!this.element.contains(event.relatedTarget)) this.close()
  }
}
